// extracted by mini-css-extract-plugin
export var avatar = "opinion-card-module--avatar--EDrlA";
export var container = "opinion-card-module--container--G-r1C";
export var contentBox = "opinion-card-module--content-box--u4YNY";
export var signature = "opinion-card-module--signature--SDVJg";
export var text = "opinion-card-module--text--vdBG3";